import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import DOMPurify from "dompurify";
import { GiPodiumWinner } from "react-icons/gi";
import { MdSportsHandball } from "react-icons/md";
import { IoCarSportSharp } from "react-icons/io5";
import { MdOutlineSportsScore } from "react-icons/md";

import ThemePanelMob_1 from "../../img/decor/theme_panel_1_mob.webp";
import ThemePanelMob_2 from "../../img/decor/theme_panel_2_mob.webp";
import ThemePanelMob_3 from "../../img/decor/theme_panel_3_mob.webp";

import ThemePanelDesc_1 from "../../img/decor/theme_panel_1_dec.webp";
import ThemePanelDesc_2 from "../../img/decor/theme_panel_2_dec.webp";
import ThemePanelDesc_3 from "../../img/decor/theme_panel_3_dec.webp";


const themes = [
    {
        title: "ГОЛОВНА СЦЕНА GET",
        color: "#BABAFE",
        reverse: false,
        items: [
            {
                title: "Трансформація:",
                text: "чотири роки війни та їхній вплив на український бізнес, уроки трансформації компаній, зміна стратегій та бізнес-моделей, перебудова процесів і управління.",
            },
            {
                title: "Капітал:",
                text: "програми підтримки бізнесу та гранти, банківське фінансування та інвестиції, можливості для МСБ, оцінка фінансових пропозицій, перевірка ризиків і потенціалу вкладень.",
            },
            {
                title: "Тренди:",
                text: "зміна поведінки споживача, економічні й технологічні тенденції, перспективні ринки та сигнали, які впливатимуть на бізнес-рішення найближчими роками, ринок праці та дефіцит кадрів. ",
            },
            {
                title: "Стійкість:",
                text: "безпека бізнесу під час війни, енергетична автономність, перебудова ланцюгів постачання, локальне виробництво, податкові рішення для постраждалого бізнесу та інструменти збереження операційної стійкості.",
            },
            {
                title: "Відновлення:",
                text: "погляд на економіку майбутнього та нові стратегічні орієнтири для бізнесу.",
            },
        ],
        imgMob: ThemePanelMob_1,
        imgDesc: ThemePanelDesc_1,
    },
    {
        title: "СЦЕНА МАРКЕТИНГОВИХ СТРАТЕГІЙ",
        color: "#FFD87C",
        reverse: true,
        items: [
            {
                title: "Ефективність: ",
                text: "маркетинг як драйвер бізнес-зростання, перформанс та бренд, вартість залучення клієнта, конверсія, CRM і retention, аналітика, ROI та пошук точок зростання без збільшення бюджетів.",
            },
            {
                title: "Увага:",
                text: "боротьба за увагу в перенасиченому інформаційному просторі, інфлюенсери та креатори, соціальні мережі, розважальний контент, ком’юніті, колаборації, нові формати і канали та способи бути помітними без постійного збільшення рекламних бюджетів.",
            },
            {
                title: "ШІ:",
                text: "автоматизація маркетингових процесів, створення та персоналізація контенту, аналітика й робота з даними, реклама, новий пошук і генеративна видача, ШІ-агенти, трансформація маркетингових команд та нові компетенції маркетолога.",
            },
            {
                title: "Споживач:",
                text: "прагматичність та диджиталізація української аудиторії, ціна і цінність продукту, довіра, відгуки та рекомендації, сервіс і клієнтський досвід, соціальні мережі, e-commerce та маркетплейси, застосунки та нові сценарії пошуку й покупки.",
            },
        ],
        imgMob: ThemePanelMob_2,
        imgDesc: ThemePanelDesc_2
    },
    {
        title: "СЦЕНА БІЗНЕС-КЕЙСІВ",
        color: "#50D6ED",
        reverse: false,
        items: [
            {
                title: "Зростання:",
                text: "рішення підприємців, які допомогли зберегти та масштабувати бізнес, змінити модель роботи, залучити грантову підтримку та знайти нові точки розвитку.",
            },
            {
                title: "Фінанси:",
                text: "типові помилки підприємців, втрата грошей у щоденних операціях, управління ресурсами та практичні рішення для більшої фінансової стійкості бізнесу.",
            },
            {
                title: "Цифровізація:",
                text: "автоматизація процесів, ШІ та цифрові інструменти для ефективної роботи, кібербезпека й цифрова гігієна підприємця без складних технічних рішень.",
            },
            {
                title: "Міжнародний розвиток:",
                text: "вихід українського бізнесу на нові ринки, пошук іноземних партнерів, адаптація пропозиції та способи презентувати український продукт за кордоном.",
            },
            {
                title: "Підприємницькі компетенції:",
                text: "навчання, стажування та міжнародний досвід, які допомагають розвивати бізнес, ветеранське підприємництво та трансформація компаній за чотири роки війни.",
            },
        ],
        imgMob: ThemePanelMob_3,
        imgDesc: ThemePanelDesc_3
    },
];

const EventThemesBase = () => {
    return (
        <section className="py-[60px] lg:py-[120px] bg-[#faf9ff]">
            <div className="container max-w-full mx-auto px-[clamp(20px,calc(20px+130*((100vw-390px)/1530)),150px)]">

                <h2 className="text-[clamp(34px,calc(34px+53*((100vw-390px)/1530)),87px)] mb-[clamp(56px,calc(56px+41*((100vw-390px)/1530)),97px)]
                 font-black text-[#26265d]  uppercase leading-[1.2]">ТЕМИ GET 2026</h2>

                 <div className="flex flex-col gap-[20px] xl:gap-[50px]">
                    {themes.map((stage, index) => (
                        <div key={index} className={`grid md:grid-cols-5 ${
                            stage.reverse ? "lg:[&>*:first-child]:order-2" : ""}`}>

                            <div className="min-h-[224px] p-[25px] pb-0 shadow-[0_0_25px_0_rgba(0,0,0,0.12)] relative
                                flex flex-col justify-between gap-[20px] md:col-span-2
                                
                                xl:pt-[75px] xl:px-[50px]">
                                    
                                <h3 className="text-[clamp(29px,calc(29px+18*((100vw-390px)/1530)),47px)] xl:max-w-[440px] text-balance max-w-[260px] font-black leading-[1.2] uppercase">
                                    {stage.title}
                                </h3>

                                <div className={`w-[calc(100%+50px)] -mx-[25px] md:hidden ${
                                    index === 0 ? "-mt-[40px]" : ""
                                }`}>
                                    <img src={stage.imgMob} className="w-full"></img>
                                </div>

                                <div className="w-[calc(100%+50px)] -mx-[25px] hidden md:block xl:w-[calc(100%+100px)]  xl:-mx-[50px]">
                                    <img src={stage.imgDesc} className="w-full"></img>
                                </div>
                            </div>

                            <div className="md:col-span-3 py-[clamp(50px,calc(50px+40*((100vw-390px)/1530)),90px)]
                                pl-[clamp(20px,calc(20px+80*((100vw-390px)/1530)),100px)]
                                pr-[clamp(35px,calc(35px+65*((100vw-390px)/1530)),100px)]"
                                style={{ backgroundColor: stage.color }}>
                                <ul className="">
                                    {stage.items.map((item, itemIndex) => (
                                        <li key={itemIndex}
                                            className={`relative pl-[25px] mb-[25px] xl:mb-[30px] xl:pl-[38px]
                                                before:absolute before:left-0 before:top-[7px]
                                                before:size-[6px] before:rounded-full xl:before:size-[12px]
                                                ${index === 0 ? "before:bg-white" : "before:bg-black"}`}>

                                            <div className="font-bold text-[18px] leading-[1.2] uppercase mb-[10px]
                                                xl:text-[24px]  xl:max-w-[560px]">
                                                {item.title}
                                            </div>

                                            <div className="leading-[1.2] text-base xl:text-[18px] ">
                                                {item.text}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                        </div>
                    ))}
                 </div>

            </div>
        </section>
    );
};

export default EventThemesBase;